export enum CheckListType {
  moveIn = 'I',
  moveOut = 'O',
  repeat = 'R'
}

export function CheckListTypeMap(value: string) {
  const map = {
    [CheckListType.moveIn]: 'Move In',
    [CheckListType.moveOut]: 'Move Out',
    [CheckListType.repeat]: 'Repeat'
  }

  return map[value];
}